'use strict';

var _createForOfIteratorHelper = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _awaitAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _excluded = ["timeout", "signal", "headers"],
    _excluded2 = ["timeout", "signal", "headers"],
    _excluded3 = ["timeout", "signal", "headers"],
    _excluded4 = ["timeout", "signal", "headers"];

var CID = require('cids');

var Client = require('../../lib/core');

var Service = require('./service');

var toUrlSearchParams = require('../../lib/to-url-search-params');
/**
 * @typedef {import('../../types').Options} Options
 * @typedef {import('ipfs-core-types/src/utils').AbortOptions} AbortOptions
 * @typedef {import('ipfs-core-types/src/pin/remote').Pin} Pin
 * @typedef {import('ipfs-core-types/src/pin/remote').AddOptions} AddOptions
 * @typedef {import('ipfs-core-types/src/pin/remote').Query} Query
 * @typedef {import('ipfs-core-types/src/pin/remote').Status} Status
 * @typedef {import('../../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/pin/remote').API<HTTPClientExtraOptions>} RemotePiningAPI
 */


var Remote =
/**
 * @param {Options} options
 */
function Remote(options) {
  _classCallCheck(this, Remote);

  this.client = new Client(options);
  /** @readonly */

  this.service = new Service(options);
};
/**
 * @type {RemotePiningAPI["add"]}
 */


Remote.prototype.add = /*#__PURE__*/function () {
  var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, _ref) {
    var timeout, signal, headers, query, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = _ref.timeout, signal = _ref.signal, headers = _ref.headers, query = _objectWithoutProperties(_ref, _excluded);
            _context.next = 3;
            return this.client.post('pin/remote/add', {
              timeout: timeout,
              signal: signal,
              headers: headers,
              searchParams: encodeAddParams(_objectSpread({
                cid: cid
              }, query))
            });

          case 3:
            response = _context.sent;
            _context.t0 = decodePin;
            _context.next = 7;
            return response.json();

          case 7:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function add(_x2, _x3) {
    return _add.apply(this, arguments);
  }

  return add;
}();
/**
 * @type {RemotePiningAPI["ls"]}
 */


Remote.prototype.ls = /*#__PURE__*/function () {
  var _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var timeout, signal, headers, query, response, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, pin;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            timeout = _ref2.timeout, signal = _ref2.signal, headers = _ref2.headers, query = _objectWithoutProperties(_ref2, _excluded2);
            _context2.next = 3;
            return _awaitAsyncGenerator(this.client.post('pin/remote/ls', {
              timeout: timeout,
              signal: signal,
              headers: headers,
              searchParams: encodeQuery(query)
            }));

          case 3:
            response = _context2.sent;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 6;
            _iterator = _asyncIterator(response.ndjson());

          case 8:
            _context2.next = 10;
            return _awaitAsyncGenerator(_iterator.next());

          case 10:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 17;
              break;
            }

            pin = _step.value;
            _context2.next = 14;
            return decodePin(pin);

          case 14:
            _iteratorAbruptCompletion = false;
            _context2.next = 8;
            break;

          case 17:
            _context2.next = 23;
            break;

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 23:
            _context2.prev = 23;
            _context2.prev = 24;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 28;
              break;
            }

            _context2.next = 28;
            return _awaitAsyncGenerator(_iterator.return());

          case 28:
            _context2.prev = 28;

            if (!_didIteratorError) {
              _context2.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context2.finish(28);

          case 32:
            return _context2.finish(23);

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[6, 19, 23, 33], [24,, 28, 32]]);
  }));

  function ls(_x) {
    return _ls.apply(this, arguments);
  }

  return ls;
}();
/**
 * @type {RemotePiningAPI["rm"]}
 */


Remote.prototype.rm = /*#__PURE__*/function () {
  var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var timeout, signal, headers, query;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            timeout = _ref3.timeout, signal = _ref3.signal, headers = _ref3.headers, query = _objectWithoutProperties(_ref3, _excluded3);
            _context3.next = 3;
            return this.client.post('pin/remote/rm', {
              timeout: timeout,
              signal: signal,
              headers: headers,
              searchParams: encodeQuery(_objectSpread(_objectSpread({}, query), {}, {
                all: false
              }))
            });

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  function rm(_x4) {
    return _rm.apply(this, arguments);
  }

  return rm;
}();
/**
 * @type {RemotePiningAPI["rmAll"]}
 */


Remote.prototype.rmAll = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4) {
    var timeout, signal, headers, query;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            timeout = _ref4.timeout, signal = _ref4.signal, headers = _ref4.headers, query = _objectWithoutProperties(_ref4, _excluded4);
            _context4.next = 3;
            return this.client.post('pin/remote/rm', {
              timeout: timeout,
              signal: signal,
              headers: headers,
              searchParams: encodeQuery(_objectSpread(_objectSpread({}, query), {}, {
                all: true
              }))
            });

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function (_x5) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * @param {Object} json
 * @param {string} json.Name
 * @param {string} json.Cid
 * @param {Status} json.Status
 * @returns {Pin}
 */


var decodePin = function decodePin(_ref6) {
  var name = _ref6.Name,
      status = _ref6.Status,
      cid = _ref6.Cid;
  return {
    cid: new CID(cid),
    name: name,
    status: status
  };
};
/**
 * @param {any} service
 * @returns {string}
 */


var encodeService = function encodeService(service) {
  if (typeof service === 'string' && service !== '') {
    return service;
  } else {
    throw new TypeError('service name must be passed');
  }
};
/**
 * @param {any} cid
 * @returns {string}
 */


var encodeCID = function encodeCID(cid) {
  if (CID.isCID(cid)) {
    return cid.toString();
  } else {
    throw new TypeError("CID instance expected instead of ".concat(cid));
  }
};
/**
 * @param {Query & { all?: boolean }} query
 * @returns {URLSearchParams}
 */


var encodeQuery = function encodeQuery(_ref7) {
  var service = _ref7.service,
      cid = _ref7.cid,
      name = _ref7.name,
      status = _ref7.status,
      all = _ref7.all;
  var query = toUrlSearchParams({
    service: encodeService(service),
    name: name,
    force: all ? true : undefined
  });

  if (cid) {
    var _iterator2 = _createForOfIteratorHelper(cid),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        query.append('cid', encodeCID(value));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  if (status) {
    var _iterator3 = _createForOfIteratorHelper(status),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _value = _step3.value;
        query.append('status', _value);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return query;
};
/**
 * @param {AddOptions & {cid:CID}} options
 * @returns {URLSearchParams}
 */


var encodeAddParams = function encodeAddParams(_ref8) {
  var cid = _ref8.cid,
      service = _ref8.service,
      background = _ref8.background,
      name = _ref8.name,
      origins = _ref8.origins;
  var params = toUrlSearchParams({
    arg: encodeCID(cid),
    service: encodeService(service),
    name: name,
    background: background ? true : undefined
  });

  if (origins) {
    var _iterator4 = _createForOfIteratorHelper(origins),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var origin = _step4.value;
        params.append('origin', origin.toString());
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return params;
};

module.exports = Remote;